import styled from 'styled-components/macro';

export const CheckItemContainer = styled.div`
  display: flex;
  text-align: left;
  justify-content: space-between;
`;
